export const documentsTranslations = {
  en: {
    title: 'Documents',
    description: 'Manage your documents and files',
    upload: {
      title: 'Upload Documents',
      button: 'Upload Documents',
      dragDrop: 'Drag & drop files here, or click to select files',
      maxSize: 'Maximum file size: 5MB'
    },
    filters: {
      title: 'Filters',
      type: {
        all: 'All Documents',
        images: 'Images',
        pdfs: 'PDFs',
        word: 'Word Documents',
        excel: 'Excel Files',
        text: 'Text Files'
      }
    },
    noDocuments: 'No documents found'
  },
  it: {
    title: 'Documenti',
    description: 'Gestisci i tuoi documenti e file',
    upload: {
      title: 'Carica Documenti',
      button: 'Carica Documenti',
      dragDrop: 'Trascina i file qui, o clicca per selezionarli',
      maxSize: 'Dimensione massima file: 5MB'
    },
    filters: {
      title: 'Filtri',
      type: {
        all: 'Tutti i Documenti',
        images: 'Immagini',
        pdfs: 'PDF',
        word: 'Documenti Word',
        excel: 'File Excel',
        text: 'File di Testo'
      }
    },
    noDocuments: 'Nessun documento trovato'
  }
};